import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { editCart } from 'cart/actions/index';
import LocationsList from 'locations/components/LocationsList';
import LocationModalManager from 'locations/containers/LocationModalManager';
import { selectLocationWithValidation } from 'locations/actions/locations';
import NotificationModalContainer from 'base/containers/NotificationModalContainer';
import LocationsCustomMessage from 'locations/components/LocationsCustomMessage';
import PageLoadSpinner from 'base/ui_components/PageLoadSpinner';
import { getCustomMessageSelector } from 'account/reducers/index';
import {
  locationsThatDeliverToAddressSelector,
  locationsForPickupSelector,
  closedLocationsSelector,
  getSortedLocationsListSelector
} from 'locations/selectors/';

import isDineInApplicationVariant from 'utils/isDineInApplicationVariant';

class LocationsContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    shouldOpenLocationDetailModal: PropTypes.bool,
    shouldOpenEditCartItemModal: PropTypes.bool,
    restaurantLocations: PropTypes.array,
    locationsThatDeliverToAddress: PropTypes.array,
    locationsForPickup: PropTypes.array,
    closedLocations: PropTypes.array,
    customMessage: PropTypes.string,
    googleLoaded: PropTypes.bool,
    isSettingAddress: PropTypes.bool
  };

  static defaultPropTypes = {
    shouldOpenLocationDetailModal: false,
    isSettingAddress: false
  };

  state = {
    selectedMapLocation: null
  };

  beginOrder = (id, fulfillmentMethod) => {
    this.props.dispatch(selectLocationWithValidation(id, fulfillmentMethod));
  };

  setSelectedLocation = id => {
    const { dispatch } = this.props;

    dispatch(
      editCart({
        online_ordering_location: id
      })
    );
  };

  render() {
    const {
      shouldOpenLocationDetailModal,
      shouldOpenEditCartItemModal,
      restaurantLocations,
      customMessage,
      locationsThatDeliverToAddress,
      locationsForPickup,
      closedLocations,
      googleLoaded,
      isSettingAddress
    } = this.props;

    return (
      <>
        <NotificationModalContainer />
        <LocationModalManager
          shouldOpenLocationDetailModal={shouldOpenLocationDetailModal}
          shouldOpenEditCartItemModal={shouldOpenEditCartItemModal}
          setSelectedLocation={this.setSelectedLocation}
        />
        {!isDineInApplicationVariant() && customMessage && (
          <LocationsCustomMessage message={customMessage} />
        )}
        {restaurantLocations.isFetching || !googleLoaded || isSettingAddress ? (
          <PageLoadSpinner />
        ) : (
          <LocationsList
            selectedMapLocation={this.state.selectedMapLocation}
            beginOrder={this.beginOrder}
            restaurantLocations={restaurantLocations}
            locationsThatDeliverToAddress={locationsThatDeliverToAddress}
            locationsForPickup={locationsForPickup}
            closedLocations={closedLocations}
            shouldOpenLocationDetailModal={shouldOpenLocationDetailModal}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    isSettingAddress: state.restaurantLocations.isSettingAddress,
    restaurantLocations: getSortedLocationsListSelector(
      state.restaurantLocations
    ),
    locationsThatDeliverToAddress: locationsThatDeliverToAddressSelector(
      state.restaurantLocations
    ),
    locationsForPickup: locationsForPickupSelector(state.restaurantLocations),
    closedLocations: closedLocationsSelector(state.restaurantLocations),
    customMessage: getCustomMessageSelector(state.account),
    modal: state.modal,
    locationSearch: state.locationSearch,
    locationDetail: state.locationDetail,
    googleLoaded: state.libraryLoad.google
  };
};

export default withRouter(connect(mapStateToProps)(LocationsContainer));
